import React, { cloneElement, isValidElement } from 'react';
import { Form } from 'antd';

import { FormFieldProps } from './types';
import { isRequiredRule } from './utils';
import styles from './styles.module.scss';

export const FormField = ({
  name,
  label,
  rules,
  variant,
  children,
  className,
  withRequiredMark = false,
  ...rest
}: FormFieldProps): React.ReactElement => {
  const controlClass = variant === 'input' ? styles.input : styles.select;
  const childWithClass = isValidElement(children)
    ? cloneElement(children as React.ReactElement<{ className?: string }>, {
        className: [
          controlClass,
          (children as React.ReactElement<{ className?: string }>).props?.className,
        ]
          .filter(Boolean)
          .join(' '),
      })
    : children;

  const hasRequired = Array.isArray(rules) && rules.some(isRequiredRule);

  // rc-field-form only binds value/onChange to Form.Item's *direct* child. A wrapper div breaks
  // Ant Design Select (React onChange does not bubble like native input change).
  return (
    <div className={styles.inputWrapper}>
      {label !== undefined && label !== null && (
        <span className={styles.innerLabel}>
          {label}
          {hasRequired && withRequiredMark && <span className={styles.requiredMark}> *</span>}
        </span>
      )}
      <Form.Item
        name={name}
        rules={rules}
        className={`${styles.formItem} ${className ?? ''}`.trim()}
        {...rest}
      >
        {childWithClass}
      </Form.Item>
    </div>
  );
};
